module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"contact-warehouse":"この倉庫に問い合わせ","title":"{location}の倉庫{access} 詳細情報｜全国の営業倉庫・貸し倉庫・ 物流倉庫を探すなら WareX","h1":"{location}の倉庫{access} 詳細","description":"{location}の倉庫{access}の詳細ページ。 WareXに無料登録すると、倉庫を探して、すぐに空き状況を確認できます。契約からご利用まで、サポート対応も充実した、新しい倉庫利用サービスです。","interchange":"IC","airport":"空港","seaport":"港","station":"駅","warehouse-at":"{location}の倉庫","min-from-origin":"{name}から車で{min}分"}}')
  delete Component.options._Ctor
}
